<div class="cx-one-ui etl-recalculation-container mx-6">
    <div class="header-container" id="header-container">
        <div class="page-title" cvLocalizedText langSection="ETL_Data_Recalculation" langKey="Data_Recalculation">Data Recalculation</div>
        <div>
            <button class="cxone-btn btn-big btn-primary" *ngIf="showRecalculateBtn" cvLocalizedText langSection="ETL_Data_Recalculation"
                langKey="Recalculate" (click)="recalculateData()">Recalculate</button>
        </div>
    </div>
    <div class="data-recalculation-details">
        <cxone-omnibar class="search-input" [itemCountLabel]="recalculationLabel" [isFilterable]="false"
            [searchPlaceholderText]="searchPlaceholderText" (searchQueryChange)="onSearchCriteriaChange($event)"
            [searchQuery]="searchInput">
            <cxone-omnibar-custom-content class="omnibar-custom-content-wrapper">
                <span class="timer-message" *ngIf="timerMessage !== ''">{{timerMessage}}</span>
            </cxone-omnibar-custom-content>
        </cxone-omnibar>
        <cxone-grid class="content-container" [gridOptions]="recalculationGridOptions" *ngIf="isLocalizationSectionLoaded"></cxone-grid>
    </div>
</div>